import { AxiosError } from 'axios';
import { ClientError } from '../store/initialState';

export const ERROR_TITLE = 'Si è verificato un errore';
export const STATUS_400_MESSAGE = 'Uno o più valori inseriti non sono validi';
export const STATUS_401_MESSAGE = 'Utente non autorizzato';
export const STATUS_403_MESSAGE =
  "L'utente non ha i permessi per eseguire questa operazione";
export const STATUS_404_MESSAGE = 'Not found';
export const STATUS_422_MESSAGE = "Non è stato possibile eseguire l'operazione";
export const STATUS_500_MESSAGE = "Errore durante l'esecuzione";

const parse400ErrorMessage = (actionType: string) => {
  switch (actionType) {
    case 'CITY_CREATE_REJECTED':
      return 'Uno o più campi sono obbligatori';

    case 'ADMIN_VIDEO_SITE_CREATE_REJECTED':
      return 'Uno o più campi non sono nel formato corretto';

    case 'ADMIN_VIDEO_SITE_UPDATE_REJECTED':
      return 'Uno o più campi non sono nel formato corretto';

    default:
      return STATUS_400_MESSAGE;
  }
};

const parse422ErrorMessage = (actionType: string) => {
  switch (actionType) {
    case 'CITY_CREATE_REJECTED':
      return 'Esiste già questo comune in questa provincia';

    case 'ADMIN_VIDEO_SITE_CREATE_REJECTED':
      return 'Esiste già un impianto con questo nome';

    case 'ADMIN_VIDEO_SITE_UPDATE_REJECTED':
      return "L'impianto non può essere modificato";

    case 'ADMIN_VIDEO_SITE_DELETE_REJECTED':
      return "L'impianto non può essere eliminato";

    case 'VIDEO_CAMPAIGN_VERIFY_REJECTED':
      return 'La campagna non può essere aggiornata';

    case 'CITY_VIDEO_SETTINGS_PUBLISH_REJECTED':
      return 'Il comune deve avere almeno un impianto attivo';

    default:
      return STATUS_422_MESSAGE;
  }
};

export const extractResponseError = (
  actionType: string,
  payload: AxiosError
): ClientError | null => {
  const { message, response } = payload;

  const responseError: ClientError = {
    statusCode: response?.status,
    statusMessage: ERROR_TITLE,
    message,
  };

  switch (response?.status) {
    case 400:
      responseError.message = parse400ErrorMessage(actionType);
      break;
    case 401:
      responseError.message = STATUS_401_MESSAGE;
      break;
    case 403:
      responseError.message = STATUS_403_MESSAGE;
      break;
    case 404:
      responseError.message = STATUS_404_MESSAGE;
      break;
    case 422:
      responseError.message = parse422ErrorMessage(actionType);
      break;
    case 500:
      responseError.message = STATUS_500_MESSAGE;
      break;
    default:
      break;
  }

  return responseError;
};

export const parseAxiosError = (error: AxiosError): ClientError => {
  return {
    message: error.message,
    statusCode: error.response?.status,
    stackMessage: error.stack,
    statusMessage: error.response?.statusText,
  };
};
